import React from 'react';

const Waitingpage = () => {
    return (
        <React.Fragment>
            <div class="waiting_page">
                <p class="waitingpage_calling">Calling…</p>
                <div class="waitingpage_profile">
                    <div class="waitingpage_pic" style={{ color: "rgb(85, 123, 255)" }}>
                    </div>
                    <p class="waitingpage_content"></p>
                </div>
                <div class="waitingpage_end">End call</div>
            </div>
        </React.Fragment>
    )
}

export default Waitingpage;